const playPauseButton = {
    template: `
        <div
            class="miniplayer-play-pause-button js-miniplayer-button"
            @click="$emit('click', $event)"
        >
          <i
              :class="isPlaying ? 'icon icon-pause' : 'icon icon-play'"
          ></i>
        </div>
    `,
    props: [ 'isPlaying' ],
    emits: [ 'click' ]

}

export default playPauseButton


